import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { LsbApi, type PostSpecialOfferRequest, type PostSpecialOfferResponse } from '@shared/api';

const postSpecialOfferEffect = createEffect((request: PostSpecialOfferRequest) => LsbApi.postSpecialOffer(request));
const clearEvent = createEvent();

const $dataStore = createStore<PostSpecialOfferResponse | null>(null)
  .on(postSpecialOfferEffect.done, (_, data) => data.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(postSpecialOfferEffect.pending, (_, data) => data)
  .on(postSpecialOfferEffect.fail, () => false)
  .on(postSpecialOfferEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(postSpecialOfferEffect, () => null)
  .on(
    postSpecialOfferEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while requesting Special Offer. Please try again.').message,
  )
  .on(postSpecialOfferEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $postSpecialOfferStore = {
  events: {
    postSpecialOffer: postSpecialOfferEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
